import { SETTINGS_TABS, SettingsTabKey } from '../features/settings/config';
import { useSettingsTabs } from '../features/settings/hooks/useSettingsTabs';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useAuthQuery } from '@/features/auth/api/auth.queries';

export function SettingsPage() {
  const { activeTab, setActiveTab } = useSettingsTabs();
  const { userProfile } = useAuthQuery();

  const visibleTabs = SETTINGS_TABS.filter((tab) => {
    if (tab.key === 'users') {
      return userProfile?.role === 'ADMIN';
    }
    return true;
  });

  const handleTabChange = (value: string) => {
    setActiveTab(value as SettingsTabKey);
  };

  return (
    <div className="h-full w-full flex justify-center overflow-y-auto p-8 pointer-events-auto">
      <div className="w-full max-w-5xl space-y-6">
        <SettingsHeader />

        <Tabs
          value={activeTab}
          onValueChange={handleTabChange}
          className="w-full"
        >
          <TabsList className="w-full gap-1">
            {visibleTabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <TabsTrigger key={tab.key} value={tab.key} className="flex-1">
                  <Icon className="mr-2 h-4 w-4 shrink-0" />
                  <span>{tab.label}</span>
                </TabsTrigger>
              );
            })}
          </TabsList>

          {visibleTabs.map((tab) => {
            const TabComponent = tab.component;
            return (
              <TabsContent key={tab.key} value={tab.key} className="mt-6">
                <div className="rounded-xl border border-slate-700 bg-slate-900">
                  <div className="px-6 py-8">
                    <TabComponent />
                  </div>
                </div>
              </TabsContent>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
}

function SettingsHeader() {
  return (
    <div className="flex items-center justify-between gap-4">
      <p className="text-sm text-slate-400">
        Manage your account, system preferences, mission alerts, and security
        policies.
      </p>
    </div>
  );
}
